import { Component, OnInit } from '@angular/core';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

@Component({
    selector: 'initialization-credit-form',
    templateUrl: './initialization-credit-form.component.html',
    styleUrls: ['./initialization-credit-form.component.scss'],
    standalone: false
})
export class InitializationCreditFormComponent implements OnInit {
  step;
  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit() {
    this.step = this.subscriptionFacade.getStep();
  }

  next() {
    this.subscriptionFacade.nextStep();
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
}
